import { render, staticRenderFns } from "./thanksnavbar.vue?vue&type=template&id=2af0b89f&"
import script from "./thanksnavbar.vue?vue&type=script&lang=js&"
export * from "./thanksnavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports